import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  year;

  constructor() { }

  ngOnInit() {
    this.setYear();
  }

  public setYear() {
    this.year = new Date().getFullYear();
  }

  public gotoCompanyWeb() {
    window.open('http://m-shop.mobi', '_blank');
  }
}
